export class LayoutTypeService {
  less?: boolean;
}
